import React from 'react';
import ServiceCard from './ServiceCard';

const CategoryList = ({ 
  category, 
  services, 
  selectedServices, 
  onServiceToggle,
  highlightColor,
  isAdmin = false
}) => {
  // Verifica se a categoria tem serviços
  if (!services || services.length === 0) {
    return null;
  }

  // Verifica se um serviço está selecionado
  const isServiceSelected = (serviceId) => {
    return selectedServices.some(s => 
      (typeof s === 'object' ? s.id === serviceId : s === serviceId)
    );
  };

  return (
    <div className="mb-6">
      <div className="flex items-center mb-3">
        {category.icone && (
          <span 
            className="mr-2 p-1 rounded-full flex items-center justify-center"
            style={{ backgroundColor: category.cor || '#E5E7EB', width: '32px', height: '32px' }}
          >
            <i className={category.icone}></i>
          </span>
        )}
        <h3 className="text-lg font-semibold">{category.nome}</h3>
      </div>
      
      <div className="pl-2">
        {services.map(service => (
          <ServiceCard
            key={service.id}
            service={service}
            isSelected={isServiceSelected(service.id)}
            onClick={onServiceToggle}
            highlightColor={highlightColor || category.cor}
            isAdmin={isAdmin}
          />
        ))}
      </div>
    </div>
  );
};

export default CategoryList; 